var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.35,
    cy: 380.8,
    r: 8.59,
    fill: "#3fe2fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.28,133.64s-42.1,250.82,73.16,276.1H75s-54.38-14.36-54.38-60.41V177.89S45.89,135.58,64.28,133.64Z",
    fill: "#3fe2fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,104.12s-15.27,29.76,20.71,52.41l3.16,13.11S97.58,166.67,131.68,104.12Z",
    fill: "#3fe2fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.42,75.53S152.58,129.17,198,200.8l36.58,8.32L196.07,237.4,205.28,255s-65,15.72-52.89,94.29l-43.89,3.52S94.15,224.67,189.13,221.08l2.29-18.92s-31-11.49-29-55.47S174.55,75.1,191.42,75.53Z",
    fill: "#3fe2fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.43,107S277,154.48,307,161.09c0,0-33.32,16.61-38.6,2.78V107Z",
    fill: "#3fe2fd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.07 430.68 141.31 457.99 171.16 412.8 276.51 405.91 277.07 430.68",
    fill: "#3fe2fd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.7,416.34H79.51A63.56,63.56,0,0,1,16,352.85V188.78a63.56,63.56,0,0,1,63.49-63.49h36a7,7,0,1,1,0,14h-36A49.54,49.54,0,0,0,30,188.78V352.85a49.54,49.54,0,0,0,49.49,49.49H351.7a49.54,49.54,0,0,0,49.49-49.49V188.78a49.54,49.54,0,0,0-49.49-49.49H318.57a7,7,0,0,1,0-14H351.7a63.56,63.56,0,0,1,63.49,63.49V352.85A63.56,63.56,0,0,1,351.7,416.34Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.19,359.85H23a7,7,0,1,1,0-14H408.19a7,7,0,0,1,0,14Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,490.67H122.49a7,7,0,0,1-6-10.62l45.05-74.34a7,7,0,0,1,12,7.26l-38.61,63.7H302.15l-34.89-64a7,7,0,0,1,12.29-6.7l40.54,74.33A7,7,0,0,1,314,490.67Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.73,255a30,30,0,0,1-30-30V205.37a7,7,0,0,1,14,0V225a16,16,0,0,0,32,0V205.37a7,7,0,0,1,14,0V225A30,30,0,0,1,215.73,255Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.73,212.37A62.4,62.4,0,0,1,152.39,150V123.87a62.34,62.34,0,1,1,124.68,0V150A62.41,62.41,0,0,1,214.73,212.37Zm0-136.84a48.39,48.39,0,0,0-48.34,48.34V150a48.34,48.34,0,0,0,96.68,0V123.87A48.39,48.39,0,0,0,214.73,75.53Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.29,353.47a7,7,0,0,1-7-6.79l-1.7-56.79c0-.2,0-.4,0-.6.42-7.68-3.76-25-16.78-38.76C276.59,237.6,259.74,231,238.73,231a7,7,0,0,1,0-14c24.65,0,45.49,8.25,60.27,23.87,16,16.89,21.06,38.3,20.6,48.83l1.69,56.52a7,7,0,0,1-6.79,7.2Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.27,349.33a7,7,0,0,1-7-7V297c0-42.62,40.09-80,85.8-80a7,7,0,0,1,0,14c-38.25,0-71.8,30.84-71.8,66v45.29A7,7,0,0,1,110.27,349.33Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.41,284.28a7,7,0,0,1-7-7.18l1.29-49.21a7,7,0,0,1,7-6.81h.19a7,7,0,0,1,6.81,7.18l-.95,36.11L212,242.13a7,7,0,0,1,7.28-.12l34.13,20,.95-32.86a7,7,0,1,1,14,.4l-1.29,44.68a7,7,0,0,1-10.54,5.84l-40.65-23.85-42.72,27A6.94,6.94,0,0,1,169.41,284.28Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.51,353.47a7,7,0,0,1-6.86-5.67l-13.84-71.12a7,7,0,0,1,1-5.14l7.13-11a7,7,0,0,1,11.75,7.61l-5.59,8.64,13.3,68.35a7,7,0,0,1-5.54,8.21A6.83,6.83,0,0,1,241.51,353.47Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.08,354.12a6.9,6.9,0,0,1-1.73-.22,7,7,0,0,1-5.06-8.51l17.22-67.87-5.22-9.93a7,7,0,0,1,12.39-6.51l6.47,12.3a7,7,0,0,1,.6,5l-17.89,70.48A7,7,0,0,1,189.08,354.12Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,173.45h-1.16a39.81,39.81,0,0,1,0-79.62h1.16a16.93,16.93,0,0,1,16.92,16.91v45.79A16.94,16.94,0,0,1,149.47,173.45Zm-1.16-65.62a25.81,25.81,0,0,0,0,51.62h1.16a2.92,2.92,0,0,0,2.92-2.92V110.74a2.91,2.91,0,0,0-2.92-2.91Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.14,173.45H280a16.94,16.94,0,0,1-16.91-16.92V110.74A16.93,16.93,0,0,1,280,93.83h1.16a39.81,39.81,0,1,1,0,79.62ZM280,107.83a2.91,2.91,0,0,0-2.91,2.91v45.79a2.92,2.92,0,0,0,2.91,2.92h1.16a25.81,25.81,0,1,0,0-51.62Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.15,107.83a5.27,5.27,0,0,1-.68,0,7,7,0,0,1-6.3-7.64l.4-4.14a59.63,59.63,0,0,0-119.26.33v4.49a7,7,0,0,1-14,0V96.34a73.63,73.63,0,0,1,147.26,0c0,.22,0,.45,0,.67l-.43,4.49A7,7,0,0,1,281.15,107.83Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.5,192.86H221.21a7,7,0,0,1,0-14H275.5a6.6,6.6,0,0,0,6.59-6.59v-6.8a7,7,0,1,1,14,0v6.8A20.61,20.61,0,0,1,275.5,192.86Z",
    fill: "#251ac7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75,161.09a7,7,0,0,1-7-7V133.64a7,7,0,0,1,14,0v20.45A7,7,0,0,1,211.75,161.09Z",
    fill: "#251ac7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.8fcbc546934bbed9c51ad827f5367ce2.svg";
export { ForwardRef as ReactComponent };